import { Stage } from './stage';
import { OpportunityStatus } from '../api/octopus';
import { Entity } from './entity';
import { DateRange } from './date-range';
import { NumericRange } from './numeric-range';
import {
  CurrencyAndDisplay,
  DateAndDisplay,
  NumberAndDisplay,
  StringAndDisplay,
} from '../types';

export interface Opportunity extends Entity {
  key: string;
  objective: string;
  abEntry?: StringAndDisplay;
  description?: string;
  status: NumberAndDisplay<OpportunityStatus>;
  cost?: CurrencyAndDisplay | null;
  actualRevenue?: CurrencyAndDisplay | null;
  forecastRevenue?: CurrencyAndDisplay | null;
  corporateRevenue?: CurrencyAndDisplay | null;
  weightedCorporateRevenue?: number;
  startDate?: DateAndDisplay | null;
  closeDate?: DateAndDisplay | null;
  currentSalesStageAge: number;
  processId: string;
  stage: Stage | null;
  currentStage?: string;
  product?: string;
  contact?: StringAndDisplay;
  owner?: StringAndDisplay | null;
  isOverdue?: boolean;
  overdueDays?: number;
  stageOverdueDays?: number | null;
}

export interface OpportunitySearch {
  key: string;
  status: OpportunityStatus;
  displayValue: string;
  objective: string;
  companyName: string;
  companyKey: string | null;
  contactName: string;
  contactKey: string | null;
  lastContactDateDisplayValue: string;
  lastContactDateValue: string;
  revenueType: string;
}

export interface OpportunityForm {
  key: string | null;
  objective: string;
  abEntryKey: string;
  abEntryName: string;
  companyName: string | null;
  companyKey: string | null;
  description: string | null;
  status: number;
  processId: string | null;
  stageId: string | null;
  cost: number | null;
  actualRevenue: number | null;
  forecastRevenue: number | null;
  closeDate: Date | null;
}

export interface OpportunityFilters {
  pipeline: string;
  date: string;
  range?: DateRange;
  teamOwner?: string[] | null;
  revenueType?: string[] | null;
  amount?: NumericRange;
}

export enum OpportunityFinalStage {
  Abandoned = 'abandoned',
  Lost = 'lost',
  Won = 'won',
}
